import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shiftId: '',
  shiftPid: 0
};

export const { actions: shiftIdActions, reducer: shiftIdReducer } = createSlice(
  {
    name: 'shiftId',
    initialState,
    reducers: {
      setShiftId: (state, action) => {
        state.shiftId = action.payload;
      },
      setShiftPid: (state, action) => {
        state.shiftPid = action.payload;
      }
    }
  }
);
